import React from 'react';

import { graphql, useFragment } from 'react-relay';

import { Inline, Text } from '@atlaskit/primitives/compiled';
import {
	type FocusAreaHealthKey,
	FocusAreaIcon,
	type FocusAreaStatusKey,
} from '@atlassian/focus-area-icon';

import type { positionFocusArea_AtlassianSearchPage$key } from './__generated__/positionFocusArea_AtlassianSearchPage.graphql';

type PositionFocusAreaProps = {
	node?: positionFocusArea_AtlassianSearchPage$key | null;
};

export const PositionFocusArea = ({ node }: PositionFocusAreaProps): React.JSX.Element => {
	const data = useFragment(
		graphql`
			fragment positionFocusArea_AtlassianSearchPage on MercuryFocusArea {
				__typename
				name
				status {
					key
				}
				health {
					key
				}
			}
		`,
		node,
	);

	return (
		<Inline space="space.100" alignBlock="center">
			<FocusAreaIcon
				status={data?.status?.key as FocusAreaStatusKey}
				health={data?.health?.key as FocusAreaHealthKey}
			/>
			<Text size="medium" weight="regular" color="color.text.subtle">
				{data?.name}
			</Text>
		</Inline>
	);
};
